import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      page: 1,
      pageCount: 0,
      thomasTechReportData: [],
      displayData: "",
      totalRecords: 0,
      showDialogDetailsBox: false,
      headerThomasTechReport: [
        { text: "Request File Name", align: "start", value: "display_file_name", class: "primary customwhite--text" },
        { text: "Response Status", value: "response_status", class: "primary customwhite--text" },
        { text: "Created", value: "created_on", class: "primary customwhite--text" },
        { text: "Response", value: "actions", class: "primary customwhite--text" },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.pageNumber(1);
  },
  computed: {
    frameSrc() {
      return this.base64String;
    },
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.thomasTechReportData = [];
      this.page = 1;
      this.pageCount = 0;
      this.totalRecords = 0;
      this.displayData = "";
      this.showDialogDetailsBox = false;
      this.pageNumber(1);
    },
    pageNumber(page) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("rt/thomas_tech_report?page_number=" + page)
        .then((response) => {
          if (response.status == 200) {
            let responseData = response.data.body;
            const newArr = responseData.map((obj) => {
              return {
                ...obj,
                created_on: Utility.displayDateFormat(obj.created_on),
                // Trim File Name
                display_file_name: obj.request_file_name ? obj.request_file_name.split("/").pop() : "",
              };
            });
            this.thomasTechReportData = newArr;
            this.pageCount = responseData[0]?.total_pages;
            this.totalRecords = responseData[0]?.total_records;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Download file function
    downloadFile(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get("rt/thomas_tech_file_url?UpdFileName=" + item.request_file_name)
        .then((response) => {
          if (response.status == 200) {
            let responseData = response.data.body;
            window.open(responseData, "_blank");
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //display outbound pupup message
    onClickDetailsView(item) {
      if (item.response_message !== null && item.response_message !== undefined && item.response_message !== "") {
        this.showDialogDetailsBox = true;
        this.displayData = item.response_message;
      } else {
        var Alert = {
          type: "error",
          isShow: true,
          message: "No details available for this record.",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        this.showDialogDetailsBox = false;
        this.displayData = "";
      }
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
